module.exports = __webpack_public_path__ + "img/96.439ef321.jpg";